// Pour que l'url change quand on clique en remote: true
window.initializeUjsPagination = function() {
  $('.ujs_pagination a[data-remote=true]').on('click', function() {
    history.pushState(null, '', $(this).attr("href"))
  });
  $(window).on('popstate', function () {
    var remoteUrl = "<a href='" + document.location.href + "'" + " data-remote='true'></a>"
    $.rails.handleRemote( $(remoteUrl) );
  });
}

$(document).on("turbolinks:load", function(){
  initializeUjsPagination();
});
